"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { Media, UnstyledButton } from "@opensea/ui-kit";
import { AccountCircle, Wallet } from "@opensea/ui-kit/icons";
import { useIsConnecting, useViewWalletFlow } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { getProfileUrlByIdentifier } from "@/components/profile/utils";
import { useConnectFlow } from "@/hooks/use-connect-flow";
import { useAddress } from "@/hooks/wallet";
export function ConnectIconButton() {
  const $ = _c(10);
  const t = useTranslations("ConnectIconButton");
  const address = useAddress();
  const isConnecting = useIsConnecting();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      source: "Top Navbar"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const connectFlow = useConnectFlow(t0);
  const viewWalletFlow = useViewWalletFlow();
  let t1;
  if ($[1] !== address || $[2] !== connectFlow || $[3] !== viewWalletFlow) {
    t1 = event => {
      if (address) {
        viewWalletFlow(address);
      } else {
        connectFlow({
          event
        });
      }
    };
    $[1] = address;
    $[2] = connectFlow;
    $[3] = viewWalletFlow;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleConnect = t1;
  let t2;
  if ($[5] !== address || $[6] !== handleConnect || $[7] !== isConnecting || $[8] !== t) {
    t2 = address ? <><UnstyledButton disabled={isConnecting} onClick={handleConnect}><Wallet /></UnstyledButton><Media lessThan="md"><Link disabled={isConnecting} href={getProfileUrlByIdentifier(address)} variant="unstyled"><AccountCircle /></Link></Media></> : <Button onClick={handleConnect} size="sm">{t("connect")}</Button>;
    $[5] = address;
    $[6] = handleConnect;
    $[7] = isConnecting;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}